import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../api/config";
import { HTTP_STATUS } from "../../../app/constants";

const namespace = "genders";

const initialState = {
  loading: null,
  gendersDetails: [],
  genderResponse: {},
  errorMessage: null,
};

// POST
export const addGenderToServer = createAsyncThunk(
  `${namespace}/addGenderToServer`,
  async (newGender, { rejectWithValue }) => {
    try {
      const response = await api.post("/gender", newGender, {
        headers: { auth: `${JSON.parse(sessionStorage.getItem("auth"))}` },
      });
      return response.data;
    } catch (err) {
      if (err.response) {
        return rejectWithValue(err.response.data);
      } else {
        return rejectWithValue({
          message: "Network error or server not reachable",
        });
      }
    }
  }
);

// GET
export const getGendersFromServer = createAsyncThunk(
  `${namespace}/getGendersFromServer`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/genders", {
        headers: { auth: `${JSON.parse(sessionStorage.getItem("auth"))}` },
      });
      return response.data;
    } catch (err) {
      if (err.response) {
        return rejectWithValue(err.response.data);
      } else {
        return rejectWithValue({
          message: "Network error or server not reachable",
        });
      }
    }
  }
);

// GET
export const getGendersCountFromServer = createAsyncThunk(
  `${namespace}/getGendersCountFromServer`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/gendersCount", {
        headers: { auth: `${JSON.parse(sessionStorage.getItem("auth"))}` },
      });
      return response.data;
    } catch (err) {
      if (err.response) {
        return rejectWithValue(err.response.data);
      } else {
        return rejectWithValue({
          message: "Network error or server not reachable",
        });
      }
    }
  }
);

// GET
export const getGendersFromServerByPagination = createAsyncThunk(
  `${namespace}/getGendersFromServerByPagination`,
  async ({ pageNo, rowSize }, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `/genderspagination?pageNo=${pageNo}&rowSize=${rowSize}`,
        {
          headers: { auth: `${JSON.parse(sessionStorage.getItem("auth"))}` },
        }
      );
      return response.data;
    } catch (err) {
      if (err.response) {
        return rejectWithValue(err.response.data);
      } else {
        return rejectWithValue({
          message: "Network error or server not reachable",
        });
      }
    }
  }
);

// PATCH
export const updateGenderInserver = createAsyncThunk(
  `${namespace}/updateGenderInServer`,
  async (updatedGender, { rejectWithValue }) => {
    try {
      const id = parseInt(updatedGender.genderId);
      const response = await api.patch(`/gender/${id}`, updatedGender, {
        headers: { auth: `${JSON.parse(sessionStorage.getItem("auth"))}` },
      });
      return response.data;
    } catch (err) {
      if (err.response) {
        return rejectWithValue(err.response.data);
      } else {
        return rejectWithValue({
          message: "Network error or server not reachable",
        });
      }
    }
  }
);

// DELETE
export const deleteGenderFromServer = createAsyncThunk(
  `${namespace}/deleteGenderFromServer`,
  async (existingGender, { rejectWithValue }) => {
    try {
      let id = parseInt(existingGender.genderId);
      let loginUser = existingGender.loginUser;
      const response = await api.patch(
        `deletegender/${id}`,
        {
          params: { loginUser },
        },
        {
          headers: { auth: `${JSON.parse(sessionStorage.getItem("auth"))}` },
        }
      );
      return response.data;
    } catch (err) {
      if (err.response) {
        return rejectWithValue(err.response.data);
      } else {
        return rejectWithValue({
          message: "Network error or server not reachable",
        });
      }
    }
  }
);

export const genderSlice = createSlice({
  name: namespace, // SliceName
  initialState,
  reducers: {
    // increment: (state) => {
    //   state.count += 1;
    // },
    // decrement: (state) => {
    //   state.count -= 1;
    // },
    // reset: (state) => {
    //   state.count = 0;
    // },
    // incrementByAmount: (state, action) => {
    //   state.count += action.payload;
    // },
    // We dont require this, if we are using extra reducers.
    // genderAdded: {
    //   reducer(state, action) {
    //     state.push(action.payload);
    //   },
    //   // "Prepare" is just for handling Datastructures.
    //   prepare(genderCode, genderName) {
    //     return {
    //       payload: {
    //         genderCode,
    //         genderName,
    //       },
    //     };
    //   },
    // },
    // "builder" is an Object which is used to handle promises(pending, fulfilled and rejected).
    // These promises are comming from CreateAyncThunk and these are the Life Cycle of Async Operations.
  },
  extraReducers: (builder) => {
    builder
      .addCase(getGendersFromServer.pending, (state) => {
        state.loading = HTTP_STATUS.PENDING;
      })
      .addCase(getGendersFromServer.fulfilled, (state, action) => {
        state.loading = HTTP_STATUS.FULFILLED;
        state.gendersDetails = action.payload.data;
        state.errorMessage = null;
      })
      .addCase(getGendersFromServer.rejected, (state, { error }) => {
        state.loading = HTTP_STATUS.REJECTED;
        state.gendersDetails = [];
        state.errorMessage = error.message;
      })
      .addCase(getGendersCountFromServer.pending, (state) => {
        state.loading = HTTP_STATUS.PENDING;
      })
      .addCase(getGendersCountFromServer.fulfilled, (state, action) => {
        state.loading = HTTP_STATUS.FULFILLED;
        state.errorMessage = null;
      })
      .addCase(getGendersCountFromServer.rejected, (state, { error }) => {
        state.loading = HTTP_STATUS.REJECTED;
        state.errorMessage = error.message;
      })
      .addCase(getGendersFromServerByPagination.pending, (state) => {
        state.loading = HTTP_STATUS.PENDING;
      })
      .addCase(getGendersFromServerByPagination.fulfilled, (state, action) => {
        state.loading = HTTP_STATUS.FULFILLED;
        state.errorMessage = null;
      })
      .addCase(
        getGendersFromServerByPagination.rejected,
        (state, { error }) => {
          state.loading = HTTP_STATUS.REJECTED;
          state.gendersDetails = [];
          state.errorMessage = error.message;
        }
      )
      .addCase(addGenderToServer.pending, (state) => {
        state.loading = HTTP_STATUS.PENDING;
      })
      .addCase(addGenderToServer.fulfilled, (state, action) => {
        // const { genderCode: GCode, genderName: GName } = action.meta.arg;
        state.loading = HTTP_STATUS.FULFILLED;
        state.genderResponse = action.payload.data;
        state.errorMessage = null;
        // state.genders.push(action.payload); // The data what i'm saving, pushing into to initialstate genders[].
      })
      .addCase(addGenderToServer.rejected, (state, { error }) => {
        state.loading = HTTP_STATUS.REJECTED;
        state.genderResponse = {};
        state.errorMessage = error.message;
      })
      .addCase(updateGenderInserver.pending, (state) => {
        state.loading = HTTP_STATUS.PENDING;
      })
      .addCase(updateGenderInserver.fulfilled, (state, action) => {
        state.loading = HTTP_STATUS.FULFILLED;
        state.genderResponse = action.payload.data;
        state.errorMessage = null;
      })
      .addCase(updateGenderInserver.rejected, (state, { error }) => {
        state.loading = HTTP_STATUS.REJECTED;
        state.genderResponse = {};
        state.errorMessage = error.message;
      })
      .addCase(deleteGenderFromServer.pending, (state) => {
        state.loading = HTTP_STATUS.PENDING;
      })
      .addCase(deleteGenderFromServer.fulfilled, (state, action) => {
        state.loading = HTTP_STATUS.FULFILLED;
        state.genderResponse = action.payload.data;
        state.errorMessage = null;
      })
      .addCase(deleteGenderFromServer.rejected, (state, { error }) => {
        state.loading = HTTP_STATUS.REJECTED;
        state.genderResponse = {};
        state.errorMessage = error.message;
      });
  },
});

// increment, decrement, reset, incrementByAmount
export const selectLoadingStatus = (state) => state.genders.loading;
export const selectAllGenders = (state) => state.genders.gendersDetails;
export const getGenderError = (state) => state.genders.errorMessage;
// export const { genderAdded } = genderSlice.actions; // We have to export the methods/actions.
export default genderSlice.reducer; // We have to export the reducer.
